<template>
	<div class="company-form">
		<form-sidebar>
			<v-form>
				<div class="form-section">
					<div class="section-head">
						<v-icon class="section-head__icon">business</v-icon>
						<span class="section-head__title">Datos de la Compañía</span>
					</div>
					<v-layout row wrap>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseSelect
								label="Tipo de Documento"
								item-text="name"
								item-value="id"
								:height="38"
								:items="documents"
								v-model="$v.model.flagTypePerson.$model"
							/>
							<span class="error--text caption" v-if="$v.model.flagTypePerson.$invalid">
								El tipo de documento es requerido
							</span>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseInput
								:height="38"
								label="Nro de Documento"
								type="number"
								v-model="$v.model.ruc.$model"
							/>
							<span class="error--text caption" v-if="!$v.model.ruc.required">
								El número de documento es requerido
							</span>
							<span class="error--text caption" v-if="!$v.model.ruc.maxLength">
								El ruc solo puede tener 13 digitos
							</span>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseInput
								:height="38"
								:label="nameLabel"
								v-model="$v.model.name.$model"
							/>
							<span class="error--text caption" v-if="$v.model.name.$invalid">
								El nombre es requerido
							</span>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell" v-if="!isLegal">
							<BaseInput
								:height="38"
								label="Apellido"
								v-model="$v.model.lastname.$model"
							/>
							<span class="error--text caption" v-if="$v.model.lastname.$invalid">
								El apellido es requerido
							</span>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell" v-else>
							<BaseInput
								:height="38"
								label="Razón Social"
								v-model="$v.model.rzSocial.$model"
							/>
							<span class="error--text caption" v-if="$v.model.rzSocial.$invalid">
								La razón social es requerida
							</span>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseInput
								:height="38"
								label="Dirección"
								v-model="$v.model.address.$model"
							/>
							<span class="error--text caption" v-if="$v.model.address.$invalid">
								La dirección es requerida
							</span>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseInput
								type="number"
								:height="38"
								label="Teléfono"
								v-model="model.phone"
							/>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseDate
								type="date"
								:height="38"
								label="Fecha de Inicio"
								v-model="model.startDateFunctions"
							/>
							<span class="error--text caption" v-if="$v.model.startDateFunctions.$invalid">
								La fecha de inicio es requerida
							</span>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseSelect
								label="Género"
								item-text="name"
								item-value="id"
								:height="38"
								:items="gender"
								v-model="model.gender"
							/>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseSelect
								label="Estado Civil"
								item-text="name"
								item-value="id"
								:height="38"
								:items="civilStatus"
								v-model="model.civilStatus"
							/>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseSelect
								readonly
								label="País"
								item-text="name"
								item-value="id"
								:height="38"
								:items="countries"
								v-model="$v.model.countryId.$model"
							/>
							<span class="error--text caption" v-if="$v.model.countryId.$invalid">
								El país es requerido
							</span>
						</v-flex>
						<v-flex xs12 sm6 md8 px-2 class="field-cell">
							<label ref="label" for="company-logo" class="logo-field">
								<vue-six-four
									id="company-logo"
									hidden
									@vue-six-four="getFile"
								/>
								<v-layout wrap align-end>
									<v-flex xs10 sm11>
										<BaseInput
											:height=38
											label="Logo de la Compañía"
											readonly
											v-model="companyLogo"
										>
										<span slot="error" class="caption error--text" v-if="!$v.companyLogo.required">
											El logo es requerido
										</span>
										</BaseInput>
									</v-flex>
									<v-flex xs2 sm1>
										<v-btn
											@click="showDialog"
											class="btn-logo"
											color="info"
											text-xs-center>
											<v-icon color="white">image</v-icon>
										</v-btn>
									</v-flex>
								</v-layout>
							</label>
						</v-flex>
					</v-layout>
				</div>

				<div class="form-section">
					<div class="section-head">
						<v-icon class="section-head__icon">vpn_key</v-icon>
						<span class="section-head__title">Credencial del Cliente</span>
					</div>
					<v-layout row wrap>
						<v-flex xs12 sm6 md4 px-2 class="field-cell">
							<BaseInput
								type="email"
								:height="38"
								label="Correo"
								v-model="$v.model.email.$model"
							/>
							<span class="error--text caption" v-if="!$v.model.email.required">
								El correo es requerido
							</span>
							<span class="error--text caption" v-else-if="!$v.model.email.email">
								Debe ingresar un correo válido. Ejemplo: micuenta@mail.com
							</span>
						</v-flex>
						<v-flex xs12 sm6 md4 px-2 class="field-cell" v-if="!customerId">
							<BaseInput
								type="password"
								:height="38"
								label="Contraseña"
								v-model="$v.model.password.$model"
							/>
							<span class="error--text caption" v-if="$v.model.password.$invalid">
								La contraseña es requerida
							</span>
						</v-flex>
					</v-layout>
				</div>

				<section class="modal-filter-footer form-footer">
					<modal-sidebar-button
						@cancel-button-clicked="closeModal"
						@accept-button-clicked="submitForm"
						:is-loading="$v.$invalid || !canSaveCustomer"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import VueSixFour from 'vue-six-four';
import { email, required, requiredIf, maxLength } from 'vuelidate/lib/validators';
import appDateMask from '@/components/shared/app-date-mask';
import helper from '@/shared/helper';

const { exactDate } = helper;

const PAGE_CUSTOMER_LIST = 'customers';

function created() {
	this.loadResources();
}

function closeModal() {
	this.goTo(PAGE_CUSTOMER_LIST);
}

function isLegal() {
	const documentSelected = this.documents.find(d => d.id === this.model.flagTypePerson) || {};
	return documentSelected.name === 'RUC';
}

// Recurso ACL del módulo de clientes/empresas.
// Como esta es una pantalla hija, su $route.name no coincide con el uri de permisos,
// por eso se fija aquí. Verifica en consola (window.permsDebug.map) y ajusta si es otro
// (por ejemplo 'users').
function permsResource() {
	return 'customers';
}

// ¿El usuario puede guardar? Crear usa el botón 'new-customer'; editar usa el CRUD 'update'.
function canSaveCustomer() {
	return this.customerId
		? this.$can(this.permsResource, 'update')
		: this.$can(this.permsResource, 'new-customer');
}

async function loadData() {
	const { data: record } = await this.$http.get(`customer/${this.customerId}`);
	if (record) {
		this.model = {
			address: record.address,
			civilStatus: record.civilStatus,
			countryId: record.countryId,
			email: record.email,
			flagTypePerson: record.flagTypePerson,
			gender: record.gender,
			name: record.name,
			lastname: record.lastname,
			phone: record.phone,
			ruc: record.ruc,
			rzSocial: record.rzSocial,
			startDateFunctions: exactDate(record.startDateFunctions, 'YYYY-MM-DD'),
		};
		this.companyLogo = record.additionalInformation.logo;
	}
}

async function loadResources() {
	const request = [
		this.$http.get('type-person'),
		this.$http.get('countries'),
		this.$http.get('company-token'),
	];
	[{ data: this.documents }, { data: this.countries }, { data: this.infoUser }]
		= await Promise.all(request);
	this.model.countryId = this.infoUser.company.countryCode === 'ECU' ? this.countries[0].id : this.countries[1].id;
	if (this.documents.length === 1) {
		this.model.flagTypePerson = this.documents[0].id;
	}
	if (this.mode === 'edit') {
		this.loadData();
	}
}

function mode() {
	return this.customerId ? 'edit' : 'create';
}

function nameLabel() {
	if (this.isLegal) {
		this.model.lastname = '';
	}
	return this.isLegal ? 'Nombre Comercial' : 'Nombre';
}

function onDate(value, modelName) {
	this.model[modelName] = value;
}

async function submitForm() {
	// Guarda por permiso: no permite crear/editar sin el permiso correspondiente.
	if (!this.canSaveCustomer) {
		this.showNotification(this.customerId
			? 'No tienes permiso para editar clientes'
			: 'No tienes permiso para crear clientes', 'warning');
		return;
	}
	const method = this.mode === 'create' ? 'post' : 'patch';
	const url = this.mode === 'create' ? 'customer' : `customer/${this.customerId}`;
	const body = this.buildBody(this.model);
	try {
		await this.$http[method](url, body);
		this.showNotification('La compañía ha sido registrada correctamente.');
		this.goTo(PAGE_CUSTOMER_LIST);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			if (err.data.message === 'EMAIL_COMPANY_DUPLICATE') {
				this.showGenericError('El correo ya se encuentra registrado.');
			} else if (err.data.message === 'CODE_COMPANY_DUPLICATE') {
				this.showGenericError('El número de documento ya se encuentra registrado.');
			} else if (err.data.message === 'CUSTOMER_EXIST_ERROR') {
				this.showGenericError('LA compañía ya se encuentra registrada.');
			}
		}
	}
}

function buildBody(model) {
	const newModel = { ...model };
	newModel.startDateFunctions = helper.formatDate(model.startDateFunctions, 'YYYY-MM-DD');
	return newModel;
}

function showDialog() {
	this.$refs.label.click();
}

async function getFile(fileInfo) {
	this.companyLogo = fileInfo.name.replace(/\s/g, '-');
	const newFile = {
		name: fileInfo.name.replace(/\s/g, '-'),
		base64data: fileInfo.sixFour,
	};
	try {
		const words = newFile.name.split('.');
		const lastItem = words.length;
		const extension = words[lastItem - 1];
		if (this.allowedFiles.indexOf(extension) > -1) {
			const { data: file } = await this.$httpProduction.post('upload-files-public', newFile);
			this.companyLogo = file.Location;
			this.model.additionalInformation = { logo: file.Location };
		} else {
			this.showNotification(`Archivo no válido, solo se permite ${this.allowedFiles.join(',')}`, 'warning');
		}
	} catch (error) {
		this.showGenericError();
	}
}

function validations() {
	const validation = {
		model: {
			address: {
				required,
			},
			countryId: {
				required,
			},
			email: {
				email,
				required,
			},
			flagTypePerson: {
				required,
			},
			lastname: {
				required: requiredIf(() => !this.isLegal),
			},
			name: {
				required,
			},
			password: {
				required: requiredIf(() => !this.customerId),
			},
			ruc: {
				required,
				maxLength: maxLength(13),

			},
			rzSocial: {
				required: requiredIf(() => this.isLegal),
			},
			startDateFunctions: {
				required,
			},
		},
		companyLogo: {
			required,
		},
	};
	return validation;
}

function data() {
	return {
		civilStatus: [
			{ id: 1, name: 'Soltero' },
			{ id: 2, name: 'Casado' },
			{ id: 3, name: 'Viudo' },
			{ id: 4, name: 'Divorciado' },
		],
		countries: [],
		documents: [],
		gender: [
			{ id: 1, name: 'Masculino' },
			{ id: 2, name: 'Femenino' },
		],
		model: {
			address: '',
			civilStatus: null,
			countryId: null,
			email: '',
			flagTypePerson: null,
			gender: null,
			name: '',
			lastname: '',
			password: '',
			phone: '',
			ruc: null,
			rzSocial: '',
			startDateFunctions: null,
			additionalInformation: {
				logo: '',
			},
		},
		valueStartDate: null,
		infoUser: {},
		companyLogo: null,
		allowedFiles: ['jpeg', 'png'],
	};
}

export default {
	name: 'customer-form',
	components: {
		appDateMask,
		BaseDate: () => import('@/components/shared/inputs/base-date'),
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		BaseSelect: () => import('@/components/shared/inputs/base-select'),
		VueSixFour,
	},
	computed: {
		isLegal,
		mode,
		nameLabel,
		permsResource,
		canSaveCustomer,
	},
	created,
	data,
	methods: {
		buildBody,
		closeModal,
		loadData,
		loadResources,
		onDate,
		submitForm,
		showDialog,
		getFile,
	},
	props: {
		customerId: {
			type: [Number, String],
		},
	},
	validations,
};
</script>

<style lang="scss" scoped>
	.company-form {
		margin: 0 auto;
		max-width: 1280px;
		padding: 4px 6px 0;
		width: 100%;
	}

	/* Tarjeta por sección */
	.form-section {
		background: #ffffff;
		border: 1px solid #eef1f4;
		border-radius: 12px;
		box-shadow: 0 1px 3px rgba(15, 42, 68, 0.04);
		margin-bottom: 18px;
		padding: 16px 18px 6px;
	}

	/* Encabezado de sección con barra de acento + icono */
	.section-head {
		align-items: center;
		border-bottom: 1px solid #eef1f4;
		display: flex;
		gap: 10px;
		margin-bottom: 18px;
		padding-bottom: 10px;
		position: relative;
	}

	.section-head::before {
		background: #02979b;
		border-radius: 3px;
		content: '';
		height: 18px;
		left: -18px;
		position: absolute;
		width: 4px;
	}

	.section-head__icon {
		color: #02979b !important;
		font-size: 20px !important;
	}

	.section-head__title {
		color: #2c404a;
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small13);
		font-weight: 700;
		letter-spacing: 0.4px;
		text-transform: uppercase;
	}

	/* Celda de campo con altura uniforme -> todas las filas quedan parejas.
	   Reserva espacio para label + input (38) + una línea de error. */
	.field-cell {
		min-height: 90px;
	}

	/* Campo de logo: botón integrado y prolijo */
	.logo-field {
		cursor: pointer;
		display: block;
	}

	.btn-logo {
		border-radius: 8px !important;
		box-shadow: none !important;
		height: 38px !important;
		margin: 0 !important;
		min-width: 38px !important;
		width: 100% !important;
		transition: transform 0.12s ease, box-shadow 0.12s ease;

		&:hover {
			box-shadow: 0 3px 8px rgba(2, 151, 155, 0.25) !important;
			transform: translateY(-1px);
		}
	}

	/* Pie del formulario */
	.form-footer {
		border-top: 1px solid #eef1f4;
		margin-top: 4px;
		padding-top: 14px;
	}

	@media (max-width: 600px) {
		.form-section {
			padding: 14px 12px 4px;
		}
		.section-head::before {
			left: -12px;
		}
		.field-cell {
			min-height: 78px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/customers/customer-form.vue